import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getYpoErrorData } from "@/components/YpoError/ypoError.constant";

const ypoErrorState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    errorData: getYpoErrorData(2), //displays general error if nothing is selected
};

const ypoErrorMutations = {
    [storeMutation.setYpoErrorData]: (state, errorIdNumber) => {
        state.errorData = errorIdNumber ? getYpoErrorData(errorIdNumber) : null;
    },
};

const ypoErrorGetters = {
    [storeGetters.ypoErrorData]: state => state.errorData,
};

export default {
    namespaced: true,
    state: {
        initialState: ypoErrorState,
        ...ypoErrorState,
    },
    mutations: { ...ypoErrorMutations },
    actions: {},
    getters: { ...ypoErrorGetters },
};
